export default __webpack_public_path__ + "static/media/duck_thug.080bcabb.png";